import React from 'react';
import cx from 'classnames';

import './Box.sass';

export const Box = ({
  children,
  center,
  className = '',
  padding = 16,
  borderRadius = 4,
  height = null,
}) => (
  <div
    className={cx('box', className, {
      'box-center': center,
    })}
    style={{padding, borderRadius, height}}
  >
    {children}
  </div>
);
